'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagMtAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0.000418056 -0.00149536H28.0002C28.0014 6.66517 28.0003 13.3318 28.0002 19.9985C18.667 19.9985 9.33339 19.9704 0.000243576 20.0015C0.000243576 13.3338 -0.00137612 6.66617 0.000418056 -0.00149536Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.6669 19.9985H28.0002V-0.00149536H14.6669V19.9985Z",
          fill: "#DE233C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.33373 2.66519H4.00039V3.99852H2.66689V5.33186H4.00039V6.66519H5.33373V5.33186H6.6669V3.99852H5.33373V2.66519Z",
          fill: "#CCCCCD"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.33372 1.99853H6.00039V3.33186H7.33356V5.99852H6.00039V7.33186H3.33372V5.99852H2.00023V3.33186H3.33372V1.99853ZM4.00039 3.99852H2.66689V5.33186H4.00039V6.66519H5.33373V5.33186H6.6669V3.99852H5.33373V2.66519H4.00039V3.99852Z",
          fill: "#7B716A",
          fillOpacity: 0.66
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.66706 5.33184C5.03525 5.33184 5.33373 5.03336 5.33373 4.66517C5.33373 4.29698 5.03525 3.9985 4.66706 3.9985C4.29887 3.9985 4.00039 4.29698 4.00039 4.66517C4.00039 5.03336 4.29887 5.33184 4.66706 5.33184Z",
          fill: "#7B716A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.29471e-05 19.9985L0.000418056 -0.00149536L14.6627 -0.0014936V0.498506L0.500023 0.498505L0.500023 19.4985L14.6627 19.4985V19.9985H2.29471e-05Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagMtAsset = forwardRef(FlagMtAsset);

export { VpFlagMtAsset as default };
